export interface Project {
  id: number;
  distributioninitial: string;
  distributionend: string;
  referencedate: string;
  originalshareindex: number;
  demographicindex: number;
  originalsharecutting: number;
  createat: string;
}

export const tabs = { list: 'list', form: 'form', process: 'process', audit: 'audit' };
